
import { useState } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { VenueCard } from "./VenueCard";
import { useVenuesBySuburbs } from "@/hooks/use-venues-by-suburbs";
import { useVenueShortlist } from "@/hooks/use-venue-shortlist";

interface VenueCarouselProps {
  eventId: string;
  suburbs: string[];
}

export const VenueCarousel = ({
  eventId,
  suburbs
}: VenueCarouselProps) => {
  const [currentApiPage, setCurrentApiPage] = useState(1);
  const {
    data: venues = [],
    isLoading
  } = useVenuesBySuburbs(suburbs);
  
  const {
    shortlistedVenues = [],
    addToShortlist,
    removeFromShortlist,
    isProcessing
  } = useVenueShortlist(eventId);

  if (isLoading) {
    return <div className="w-full flex justify-center py-8">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>;
  }

  if (!venues.length) {
    return <div className="text-center py-6 text-muted-foreground">
        No venues found for selected suburbs
      </div>;
  }

  // Filter out already shortlisted venues to avoid duplicates
  const shortlistedVenueIds = shortlistedVenues.map(v => v.venue_id);
  const filteredVenues = venues.filter(venue => !shortlistedVenueIds.includes(venue.venue_id));

  if (!filteredVenues.length) {
    return <div className="text-center py-6 text-muted-foreground">
        All available venues have been added to your shortlist
      </div>;
  }

  const handleToggleShortlist = (venueId: string) => {
    // Check if shortlistedVenues is defined before using some()
    const isShortlisted = shortlistedVenues?.some(v => v.venue_id === venueId) || false;
    if (isShortlisted) {
      removeFromShortlist(venueId);
    } else {
      addToShortlist(venueId);
    }
  };

  return <div className="w-full">
      <h3 className="font-semibold mb-4">Suggested Venues</h3>
      <Carousel className="w-full" opts={{
      align: 'start',
      containScroll: 'trimSnaps'
    }}>
        <CarouselContent className="-ml-2 md:-ml-4">
          {filteredVenues.map(venue => <CarouselItem key={venue.venue_id} className="pl-2 md:pl-4 basis-4/5 sm:basis-3/4 md:basis-3/5 lg:basis-2/5">
              <VenueCard venue={venue} isInShortlist={false} onToggleShortlist={() => handleToggleShortlist(venue.venue_id as string)} isProcessing={isProcessing} />
            </CarouselItem>)}
        </CarouselContent>
        <div className="hidden sm:block">
          <CarouselPrevious />
          <CarouselNext />
        </div>
      </Carousel>
    </div>;
};
